import { View, Link, colors } from '@fairygodboss/ui';
import React from 'react';

import { StyledModerationMenu } from '../../components/SharedLayout/ModerationMenu/ModerationMenu';
import { Provider as CommunityContextProvider } from '../../context/CommunityContext';
import getContent from '../../utils/getContent';
import useUser from '../../utils/useUser';

const FoldLink = () => (
    <View>
        <Link
            href="/advice"
            target="_self"
            variant="inline"
            className="fold-link"
        >
            <style global jsx>
                {`
                    .fold-link {
                        text-decoration: none !important;
                        font-size: 16px;
                        line-height: 20px;
                        font-weight: 600;
                    }
                    .fold-link:visited {
                        color: ${colors.primary[60]} !important;
                        text-decoration: none !important;
                    }
                    .fold-link:hover {
                        color: ${colors.primary[60]} !important;
                    }
                    .fold-link:hover > div > svg > path {
                        fill: ${colors.primary[80]};
                    }
                    .fold-link:visited > div > svg > path {
                        fill: ${colors.primary[60]};
                    }
                    .fold-link svg {
                        height: 14px;
                    }
                `}
            </style>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.5919 13.0307C12.0287 13.4812 12.0287 14.2116 11.5919 14.662C11.1551 15.1125 10.4468 15.1125 10.0099 14.662L4.4082 8.81563C3.97136 8.36513 3.97136 7.63473 4.4082 7.18424L10.0099 1.33779C10.4468 0.887297 11.1551 0.887297 11.5919 1.33779C12.0287 1.78829 12.0287 2.51869 11.5919 2.96919L6.78113 7.99993L11.5919 13.0307Z"
                    fill={colors.neutral[100]}
                />
            </svg>
            ARTICLES & ADVICE
        </Link>
    </View>
);

export const AboveTheFoldLink = ({ hash, type }) => {
    const { user } = useUser();
    const { content } = getContent(type, hash, false);
    return (
        <View
            display="flex"
            justifyContent="space-between"
            pt={{ _: '32px', sm: '32px', md: '40px' }}
            pb={{ _: '24px', sm: '34px' }}
        >
            <FoldLink />
            <CommunityContextProvider
                singleAttributionContentHash={hash}
                attributionMode="single"
                content={[content]}
            >
                <StyledModerationMenu
                    hash={hash}
                    type="editorial-content"
                    isAdmin={user.isAdmin}
                />
            </CommunityContextProvider>
        </View>
    );
};
